import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=ee5bb32e&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=js&"
export * from "./addService.vue?vue&type=script&lang=js&"
import style0 from "./addService.vue?vue&type=style&index=0&id=ee5bb32e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5bb32e",
  null
  
)

export default component.exports